export default "__VITE_ASSET__DFg3gnk1__"